/**
 * Paleta de colores WingDrive - Moderna y profesional
 * Diseñada con azules profundos y brillantes
 */
export const colors = {
  // Colores principales - Azul WingDrive
  primary: {
    50: '#f0f7ff',
    100: '#e0f0ff',
    200: '#bae0ff',
    300: '#7cc8ff',
    400: '#4db0ff',
    500: '#2563eb', // Azul brillante principal
    600: '#1d4ed8',
    700: '#1e3a8a', // Azul oscuro
    800: '#1e3a8a',
    900: '#0f172a',
  },
  
  // Colores secundarios - Azul más oscuro
  secondary: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#1e293b', // Azul oscuro profundo
    600: '#0f172a',
    700: '#0f172a',
    800: '#020617',
    900: '#000000',
  },
  
  // Colores de estado
  success: {
    50: '#f0fdf4',
    500: '#22c55e',
    600: '#16a34a',
  },
  
  error: {
    50: '#fef2f2',
    500: '#ef4444',
    600: '#dc2626',
  },
  
  warning: {
    50: '#fffbeb',
    500: '#f59e0b',
    600: '#d97706',
  },
  
  // Neutros
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
  
  // Base
  white: '#ffffff',
  black: '#000000',
}
